import { apiWrapper, apiCancel } from '../wrapper'

export const initial = 'base'
//const baseUrl = 'http://192.168.18.83:801/'
const baseUrl = process.env.REACT_APP_SERVICE_CORE_URL
const appCode = process.env.REACT_APP_SERVICE_CORE_APPCODE
const outputType = 'json'

export const authConnect = 'auth/connect/'
export const notificationCheck = 'notification/check/'
export const notificationCheckRapel = 'notification/checkrapel/'
export const authGetAccessRole = 'auth/getAccessRole/'
export const authGetAccessMenus = 'auth/getAccessMenus/'
export const authGetHoliday = 'auth/getHoliday/'

export const accessCreate = 'access/create/'
export const menuList = 'menu/list/'
export const empSideMenuList = 'Kepegawaian/SideMenu/list/'

export const sampleCreate = 'sample/sample/create/'
export const sampleList = 'sample/sample/list/'
export const sampleDetail = 'sample/sample/detail/'
export const sampleUpdate = 'sample/sample/update/'
export const sampleInactive = 'sample/sample/inactive/'
export const sampleActive = 'sample/sample/active/'

export const strukturOrganisasiCreate = 'master/strukturOrganisasi/create/'
export const strukturOrganisasiList = 'master/strukturOrganisasi/list/'
export const strukturOrganisasiDetail = 'master/strukturOrganisasi/detail/'
export const strukturOrganisasiDetailDraft = 'master/strukturOrganisasi/detail_draft/'
export const strukturOrganisasiUpdate = 'master/strukturOrganisasi/update/'
export const strukturOrganisasiUpdateDraft = 'master/strukturOrganisasi/updateDraft/'
export const strukturOrganisasiInactive = 'master/strukturOrganisasi/inactive/'
export const strukturOrganisasiInactiveDraft = 'master/strukturOrganisasi/inactiveDraft/'
export const strukturOrganisasiActive = 'master/strukturOrganisasi/active/'
export const strukturOrganisasiHirarki = 'master/strukturOrganisasi/unitHirarki/'
export const strukturOrganisasiEselon = 'master/strukturOrganisasi/eselon/'
export const strukturOrganisasiEselonDraft = 'master/strukturOrganisasi/eselonDraft/'
export const strukturOrganisasiCountDraft = 'master/strukturOrganisasi/countDraft/'
export const strukturOrganisasiDraft = 'master/strukturOrganisasi/draft/'
export const strukturOrganisasiSubmitDraft = 'master/strukturOrganisasi/submitDraft/'
export const strukturOrganisasiPeriodList = 'master/strukturOrganisasi/periodList/'
export const strukturOrganisasiBknServiceOrganisasi = 'master/strukturOrganisasi/bknServiceOrganisasi/'

export const standarKompetensiCreate = 'master/CompetencyStandard/create/'
export const standarKompetensiList = 'master/CompetencyStandard/list/'
export const standarKompetensiDetail = 'master/CompetencyStandard/detail/'
export const standarKompetensiDetailStankom = 'master/CompetencyStandard/detail_stankom/'
export const standarKompetensiUpdate = 'master/CompetencyStandard/update/'
export const standarKompetensiInactive = 'master/CompetencyStandard/inactive/'
export const standarKompetensiActive = 'master/CompetencyStandard/active/'
export const kompetensiList = 'master/CompetencyStandard/get_competence/'
export const kompetensiLevel = 'master/CompetencyStandard/get_competencelevel/'

export const notificationList = 'pages/notification/list/'
export const notificationFlagRead = 'pages/notification/flag/'

//dashboard->activity
export const activityList = 'pages/activity/list/'

// rudi--pengaturan cron
export const settingCronList = "pengaturan/cron/lists/"
export const settingCronHistory = "pengaturan/cron/history/"
export const settingCronInactive = "pengaturan/cron/doinactive/"
export const settingCronActive = "pengaturan/cron/doactive/"
export const settingCronForce = "pengaturan/cron/force/"
export const settingCronCancel = "pengaturan/cron/cancel/"

//export const cancelToken = () => apiCancel
export const cancelToken = () => {
    return apiCancel()
}
export const apiRequest = async (method, route, data = { params: null, body: null, cancelToken: null }, needToken = true) => {
    if (needToken) {
        const thisTime = (Math.floor(Date.now() / 1000))
        const expire = localStorage.getItem(initial + 'accessExpired')
        if (expire < thisTime) {
            await apiWrapper(baseUrl, initial, appCode, outputType, 'post', 'auth/getAccessToken/', data)
                .then(result => {
                    localStorage.setItem(initial + 'accessToken', result.response.access_token)
                    return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
                })
                .catch(result => {
                    return Promise.reject('Tidak dapat mengambil accessToken');
                })
        } else {
            return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
        }
    }
    return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
}